module.exports = __webpack_public_path__ + "static/media/dotted-spiral.6b6f1b8d.mp3";